/*
 * @Description: What's this for
 */
export default {
    label: '新闻列表',
    type: 'news',
    property: '',
    value: []
}
